export const basePhotoUrl = process.env.REACT_APP_IMGIX_HOST
export const nuglHost = process.env.REACT_APP_NUGL_HOST



// WEBPACK FOOTER //
// ./src/const/Paths.js